
export function useEventToPromise() {
    let listener: (() => void) | undefined;
    const eventToPromise = function<T>(arg: T): Promise<T> {
        listener = undefined;
        return new Promise((resolve) => {
            listener = () => {
                listener = undefined;
                resolve(arg);
            };
        });
    };
    const fireListener = () => {
        listener?.();
    };
    const resetListener = () => {
        listener = undefined;
    };
    return [fireListener, eventToPromise, resetListener] as const;
}
